import { render, staticRenderFns } from "./NFCPopup.vue?vue&type=template&id=3de9fc7c&scoped=true&"
import script from "./NFCPopup.vue?vue&type=script&lang=js&"
export * from "./NFCPopup.vue?vue&type=script&lang=js&"
import style0 from "./NFCPopup.vue?vue&type=style&index=0&id=3de9fc7c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de9fc7c",
  null
  
)

export default component.exports